import { useMemo } from 'react';
import { useAppSelector } from 'appRedux/hooks';

export const useIsLoggedIn = () => {
  const { loaded, loading, error } = useAppSelector(({ user }) => user);

  const isLoggedIn = useMemo(() => loaded, [loaded]);
  const isLoginPending = useMemo(() => loading, [loading]);

  return {
    isLoggedIn,
    isLoginPending,
    loginError: error
  };
};
